<!-- Dialog header -->
<div class="modal modal--md">
  <!-- Dialog content -->
  <div class="modal__cont">
    @if (!prepaymentFailed) {
      <img src="assets/achievements-accomplishment.png" width="256" height="256" alt="success" class="mt--200">
    }

    @let state = state$ | async;

    @if (state.status === LoadableStatus.LOADED) {
      <h2 class="mt--150 engagement-complete-dialog-header">{{ state.data.headline }}</h2>
      <p class="mt--100 engagement-complete-dialog-body">{{ state.data.body }}</p>
    } @else if (state.status === LoadableStatus.LOADING) {
      <mat-spinner class="position-fixed" @fadeInOut></mat-spinner>
    } @else if (state.status === LoadableStatus.ERROR) {
      <p class="mt--100 engagement-complete-dialog-body">{{ state.error?.message ?? 'An error occurred while loading the data. Try again later.' }}</p>
    }

    <!-- Dialog footer (action buttons) -->
    <div class="mt--150 grid-row grid-row--jcb">
      <div class="grid-col grid-col--auto">
        <button
          andButton
          color="primary"
          size="large"
          (click)="dialogRef.close()"
          type="button"
        >
          {{ continueButtonText }}
        </button>
      </div>
    </div>
  </div>
</div>
